module.exports = __webpack_public_path__ + "img/role2.b7a80ee5.gif";